/* eslint-disable no-console */
/** @jsx jsx */
import { useState, useEffect } from 'react'
import { jsx } from 'theme-ui'
import { updateConsents, setConfig } from '@uswitch/rvuconsent'
import Button from '../../../atoms/button'
import Card from '../../../atoms/card'
import ProgressCircle from '../../form/progress-circle'
import Icon from '../../../atoms/icon'

setConfig({
  apiPath: 'https://www.money.co.uk/consent',
  clientId: 'fs-core',
  brand: 'money',
})

const Unsubscribe = () => {
  const [unsubscribed, setUnsubscribed] = useState(false)
  const [loading, setLoading] = useState(true)
  const [unsubscribedError, setUnsubscribedError] = useState(false)
  const [resubscribed, setResubscribed] = useState(false)

  let unsub: string | null = null
  let canvasName: string | null = null
  if (typeof window !== 'undefined') {
    // example url with query params
    // http://localhost:3000/unsubscribe?unsub=69b1120d-b2d2-47e3-811e-889d3c027aa3&canvasname=sme-welcome:sme-monthly-consent
    const urlSearchParams = new URLSearchParams(window.location.search)
    const params = Object.fromEntries(urlSearchParams.entries())
    unsub = params?.unsub
    if (params?.canvasname && params?.canvasname.length > 1) {
      canvasName = params?.canvasname
    } else {
      canvasName = params?.campaignname
    }
  }
  const defaultText = 'We are currently processing your unsubscription'
  const successText = 'You’ll no longer hear from us unless you ask to.'
  const errorText = 'We’re unable to unsubscribe you from our emails at this time.'
  const errorTextTwo =
    'Please send an email to unsubscribe@money.co.uk and we’ll take care of it for you.'
  const reSubSuccessText =
    'You’ll continue to receive our latest deals, guides and tips to help you stay on top of your finances.'
  const reSubText =
    'Oops, did you unsubscribe by accident. You can re subscribe by clicking the button below'

  const consent = canvasName?.split(':')?.[1]
  useEffect(() => {
    // We only want to report consent on the client
    if (typeof window !== 'undefined') {
      if (!unsub) {
        setUnsubscribedError(true)
        setLoading(false)
        return
      }

      updateConsents({
        uuid: unsub,
        consents: [
          {
            status: false,
            brand: 'money',
            name: consent || '',
            source: 'money.unsubscribe',
            sourceUrl: '/unsubscribe',
          },
        ],
      })
        .then(() => {
          setUnsubscribed(true)
          setLoading(false)
        })
        .catch((err) => {
          if (err) {
            setLoading(false)
            setUnsubscribedError(true)
          }
        })
    }
  }, [consent, unsub])

  const titleText = () => {
    if (loading && !unsubscribed) {
      return 'We’re sorry to see you go!'
    }
    if (!loading) {
      if (unsubscribedError) {
        return 'Oops ... something’s gone wrong'
      }
      if (resubscribed) {
        return 'You’ve successfully resubscribed'
      }

      if (unsubscribed) {
        return 'You’ve successfully unsubscribed!'
      }
    }

    return ''
  }

  return (
    <div className='Unsubscribe'>
      <Card variant='plum'>
        {loading && !unsubscribed && <Icon glyph={'email-cancel'} brand='money' size={64} />}
        {!loading && (
          <Icon
            glyph={unsubscribedError ? 'email-error' : 'tick-circle-bg'}
            brand='money'
            size={64}
          />
        )}
        <h2 className='Unsubscribe__title'>{titleText()}</h2>
        {loading && (
          <div className='Unsubscribe__spinner'>
            <ProgressCircle sx={{ maxHeight: '32px' }} />
          </div>
        )}
        {!resubscribed && (
          <p
            className='Unsubscribe__text'
            dangerouslySetInnerHTML={{
              __html: unsubscribedError ? errorText : unsubscribed ? successText : defaultText,
            }}
          />
        )}

        {!loading && (
          <p className='Unsubscribe__resub'>
            {resubscribed ? reSubSuccessText : unsubscribedError ? errorTextTwo : reSubText}
          </p>
        )}
        {unsub && consent && unsubscribed && !resubscribed && (
          <Button
            variant='secondary'
            size='md'
            type='button'
            onClick={() => {
              setLoading(true)
              updateConsents({
                uuid: unsub,
                consents: [
                  {
                    status: true,
                    brand: 'money',
                    name: consent,
                    source: 'money.unsubscribe',
                    sourceUrl: '/unsubscribe',
                  },
                ],
              }).then(() => {
                setResubscribed(true)
                setLoading(false)
              })
            }}
          >
            Resubscribe now
          </Button>
        )}
      </Card>
    </div>
  )
}

export default Unsubscribe
